import {Component, OnInit, NgZone} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {AppLoadingEventsEmitter} from 'src/app/modules/shared/events/loading.events';
import {AuthService} from 'src/app/modules/shared/services/auth.service';
import {UsersService} from 'src/app/modules/shared/services/users.service';
import {NotificationsService} from 'src/app/modules/shared/services/notification.service';
import {LocalisationService} from 'src/app/modules/shared/services/localisation.service';
import {SocialService} from 'src/app/modules/shared/services/social.service';

@Component({
    selector: 'app-login-admin',
    templateUrl: './login.admin.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginAdminComponent implements OnInit {

    constructor(
        private readonly router: Router,
        private readonly appIsLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly authService: AuthService,
        private readonly usersService: UsersService,
        private readonly notificationService: NotificationsService,
        private readonly localisationService: LocalisationService,
        private readonly socialService: SocialService,
        private readonly ngZone: NgZone,
        private readonly route: ActivatedRoute,
    ) {
    }

    ngOnInit() {
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.route.queryParams.subscribe(params => {
            const token = params.token;

            this.usersService.adminLogin(token).subscribe(data => {
                this.authService.setJWT(data.token);

                window.location.href = '/';
            });
        });
    }
}
